module.exports = __webpack_public_path__ + "static/media/earth-day.b9eb43b9.jpg";